<template>
    <!-- 电动车险费用及理赔 -->
    <div>
        <!-- <div style="font-size:20px;float:left;margin:40px;font-weight:600">电动车险费用及理赔</div> -->
        <div style="height:auto;background-color:white;margin:5px 5px 20px 5px;padding-bottom: 20px;">
            <!-- 查询框 -->
            <div style="margin-left:3%">
                <el-row style=" padding: 20px 0;">
                    <el-col :span="6">
                        <div style="display:inline-block">
                            <span>组织架构</span>
                            <el-cascader v-model="condition.organize_ids" clearable style="margin-left:10px;width:300px"
                                collapse-tags :props="props"></el-cascader>
                        </div>
                    </el-col>
                    <el-col :span="4">
                        <span>时间</span>
                        <el-date-picker v-model="condition.years_date" type="month" placeholder="请选择" :clearable="false"
                            value-format="yyyy-MM" style="margin-left: 10px;width: 70%;">
                        </el-date-picker>
                    </el-col>
                    <el-col :span="3">
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Find">
                            查询</el-button>
                        <el-button
                            style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;"
                            @click="Update">
                            更新</el-button>
                    </el-col>
                    <el-col :span="2">
                        <download-excel class="export-excel-wrapper" :fields="download_excel" name="雇主险电动车统计报表"
                            :fetch="ExportForm" style="top:100px;width:5%">
                            <el-button
                                style="width: 85px; background-color: #006E4B; color: #FFFFFF; border: 1px solid #006E4B;">
                                导出</el-button>
                        </download-excel>
                    </el-col>
                </el-row>
            </div>

            <div style="margin: 10px 3% 0px;overflow-y:hidden;overflow-x: auto;">
                <div style="height: 370px;min-width: 1540px;">
                    <div style="border:1px solid #ccc;width: 99.5%;height: 370px;float: left;">
                        <div
                            style="margin-top: 20px;margin-left:20px;font-weight: 600;display: flex; align-items: center;">
                            <img src="../../../src/assets/小绿条.png"
                                style="width: 4px; height: 20px;margin-right: 8px;" />
                            <span>出险理赔统计表 </span>
                        </div>
                        <div style="width: 100%;height: 370px;" id="main1">
                        </div>
                    </div>
                </div>
            </div>

            <!-- 表格 -->
            <div style="margin:0 3%;margin-top:30px">
                <el-row>
                    <el-table :header-cell-style="{ background: '#d3eae2', color: '#000000' }" height="574px"
                        :row-class-name="tableRowClassName" ref="multipleTable" :data="tableData" tooltip-effect="dark"
                        style="width: 100%" @selection-change="handleSelectionChange">
                        <el-table-column align="center" label="序号">
                            <template slot-scope="scope_1">
                                {{ scope_1.$index + 1 }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="organize_name" align="center" label="架构">
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" :label="this_year">
                            <el-table-column prop="insurance_company_expenses" align="center" label="支付保险公司费用">
                            </el-table-column>
                            <el-table-column prop="payment_insurance_company" align="center" label="收保险公司理赔款">
                            </el-table-column>
                            <el-table-column prop="pay_compensation_employees" align="center" label="支付员工理赔款">
                            </el-table-column>
                            <el-table-column prop="difference" align="center" label="差额"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" :label="last_year">
                            <el-table-column prop="absence_days" align="center" label="支付保险公司费用"></el-table-column>
                            <el-table-column prop="absence_days" align="center" label="收保险公司理赔款"></el-table-column>
                            <el-table-column prop="absence_days" align="center" label="支付员工理赔款"></el-table-column>
                            <el-table-column prop="absence_days" align="center" label="差额"></el-table-column>
                        </el-table-column>
                        <el-table-column prop="create_time" align="center" :label="the_previous_year">
                            <el-table-column prop="absence_days" align="center" label="支付保险公司费用"></el-table-column>
                            <el-table-column prop="absence_days" align="center" label="收保险公司理赔款"></el-table-column>
                            <el-table-column prop="absence_days" align="center" label="支付员工理赔款"></el-table-column>
                            <el-table-column prop="absence_days" align="center" label="差额"></el-table-column>
                        </el-table-column>
                    </el-table>
                </el-row>
                <el-row style="margin-top: 10px; text-align: center;">
                    <el-pagination background @current-change="handleCurrentChange" :page-size="page_size"
                        layout=" prev, pager, next, jumper" :total="total">
                    </el-pagination>
                </el-row>
            </div>
        </div>
    </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
    data() {
        var organizeFind = async (e, spare8) => {
            var organizeList = await this.$globals.AxiosPost("organize/findHierarchy", {
                identification: "1",
                organize_id: e,
                spare8: spare8,
            });
            return organizeList.data;
        };
        return {
            //列表相关
            page_num: 1,
            page_size: 10,
            total: 0,
            tableData: [],
            tableDatas: [],
            //条件
            condition: {
                data: "",
            },

            //复选框ids
            ids: [],

            //页面相关
            dialogVisible: false,

            //组织架构数据
            organizeList: [],

            //条件
            condition: {
                years_date: this.$globals.getNowTimes(),
                organize_ids: [],
            },

            download_excel: {
                "架构": "organize_name",
                "支付保险公司费用": "insurance_company_expenses",
                "收保险公司理赔款": "payment_insurance_company",
                "支付员工理赔款": "pay_compensation_employees",
                "差额": "difference"
            },
            this_year: Number(this.$globals.getNowTimes().split('-')[0]),
            last_year: Number(this.$globals.getNowTimes().split('-')[0]) - 1,
            the_previous_year: Number(this.$globals.getNowTimes().split('-')[0]) - 2,
            chart: {},
            //级联下拉配置
            props: {
                lazy: true,
                async lazyLoad(node, resolve) {
                    if (node.level === 0) {
                        return resolve(await organizeFind('', 'group'));
                    } else {
                        resolve(await organizeFind(node.data.id, ''));
                    }
                },
                value: "id",
                label: "organize_name",
                children: "organizeList",
                checkStrictly: true,
                multiple: true,
            },

        }
    },
    methods: {
        //分页
        handleCurrentChange(val) {
            this.page_num = val;
            this.Find();
        },
        //图表
        async Find_Tu() {
            var url = "reportOtherRisks/getReport";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.chart = data;
                    if (data == null) {
                        this.chart = [
                            {
                                years_date: "",
                                insurance_company_expenses: "",
                                payment_insurance_company: "",
                                pay_compensation_employees: ""
                            },
                            {
                                years_date: "",
                                insurance_company_expenses: "",
                                payment_insurance_company: "",
                                pay_compensation_employees: ""
                            },
                            {
                                years_date: "",
                                insurance_company_expenses: "",
                                payment_insurance_company: "",
                                pay_compensation_employees: ""
                            }
                        ]
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }

            echarts.init(document.getElementById('main1')).setOption({
                grid: {
                    top: '60px',
                    left: '90px',
                    right: '80px',
                    bottom: '80px'
                },
                legend: { left: 50, top: 20 },
                tooltip: {
                    trigger: "axis",
                    axisPointer: {
                        type: 'none'
                    }
                },
                dataset: {
                    dimensions: ['product', '支付保险公司费用', '收保险公司理赔', '支付员工理赔款'],
                    source: [
                        { product: this.chart[0].years_date, 支付保险公司费用: this.chart[0].insurance_company_expenses, 收保险公司理赔: this.chart[0].payment_insurance_company, 支付员工理赔款: this.chart[0].pay_compensation_employees },
                        { product: this.chart[1].years_date, 支付保险公司费用: this.chart[1].insurance_company_expenses, 收保险公司理赔: this.chart[1].payment_insurance_company, 支付员工理赔款: this.chart[1].pay_compensation_employees },
                        { product: this.chart[2].years_date, 支付保险公司费用: this.chart[2].insurance_company_expenses, 收保险公司理赔: this.chart[2].payment_insurance_company, 支付员工理赔款: this.chart[2].pay_compensation_employees }
                    ]
                },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [
                    { type: 'bar', barWidth: '10%', color: '#008E60' },
                    { type: 'bar', barWidth: '10%', color: '#FFA53C' },
                    { type: 'bar', barWidth: '10%', color: '#0196FD' }
                ]
            })
        },
        //查询
        async Find() {
            this.this_year = Number(this.condition.years_date.split('-')[0]);
            this.last_year = Number(this.condition.years_date.split('-')[0]) - 1;
            this.the_previous_year = Number(this.condition.years_date.split('-')[0]) - 2;
            this.Find_Tu();
            var url = "reportOtherRisks/selectReportOtherRisks";
            var record = {
                page_num: this.page_num,
                page_size: this.page_size,
                years_date: this.condition.years_date + '-01',
                organizeIds_num: this.condition.organize_ids[this.condition.organize_ids.length - 1],
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableData = data.list;
                    this.total = data.total;
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        async Update() {
            var url = "reportOtherRisks/refreshReportOtherRisks";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                if (code === '200') {
                    this.tableData = [];
                    this.page_num = 1;
                    this.page_size = 10;
                    this.total = 0;
                    this.$message.success("更新成功");
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //导表
        async ExportForm() {

            var url = "reportOtherRisks/selectReportOtherRisks";
            var record = {
                years_date: this.condition.years_date + '-01'
            };
            var data = await this.$globals.AxiosPost(url, record);
            if (data === "-2000") {
                this.$message.error("服务器未响应！请稍后重试");
            } else {
                var code = data.code;
                var data = data.data;
                if (code === '200') {
                    this.tableDatas = data.list;
                    this.total = data.total;
                    if (this.tableDatas.length > 0) {
                        this.$message.success("导表成功！文件下载中！");
                        return this.tableDatas;
                    } else {
                        this.$message.success("没有可以导出的数据！");
                        return null;
                    }
                } else {
                    this.$message.warning("请求失败！请稍后重试");
                }
            }
        },
        //初始化组织架构及下面的人
        async organizeFind() {
            var organizeList = await this.$globals.AxiosPost("organize/selectOrganizeStaff", {
                identification: "1",
            });
            this.organizeList = this.getTreeData(organizeList.data);

        },
        getTreeData(data) {
            // 循环遍历json数据
            for (var i = 0; i < data.length; i++) {

                if (data[i].organizeList.length < 1) {
                    // children若为空数组，则将children设为undefined
                    data[i].organizeList = undefined;
                } else {
                    // children若不为空数组，则继续 递归调用 本方法
                    this.getTreeData(data[i].organizeList);
                }
            }
            return data;
        },
    },
    created() {
        this.Find();
        this.organizeFind();
    }
}
</script>

<style scoped="scoped">
.el-button--goon:focus,
.el-button--goon:hover {
    background: #006E4B;
    color: #fff;
}

.el-button--goon {
    color: #FFF;
    background-color: #006E4B;
    width: 85px;
}

.el-table .warning-row {
    background: oldlace;
}

.el-table .success-row {
    background: #f0f9eb;
}
</style>


// WEBPACK FOOTER //
// electric_vehicle_insurance.vue?2b37e743